import styled from 'styled-components'
import { styled as muiStyled } from '@mui/system'
import { DialogContent } from '@mui/material'

export const SidebarItemText = styled.span`
  color: ${({ $disabled, $active }) =>
    $disabled ? '#94a3b8' : $active ? '#0f766e' : '#334155'};
  font-family: Inter, Outfit, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ $active }) => ($active ? 700 : 600)};
  line-height: 1.25;
  opacity: 0;
  white-space: nowrap;
  transform: translateX(-4px);
  transition: opacity 0.16s ease, transform 0.16s ease;
`
export const SidebarItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
  overflow: hidden;
`

export const SidebarContainer = styled.div`
  width: 76px;
  min-height: 100vh;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.96);
  border-right: 1px solid rgba(203, 213, 225, 0.72);
  box-shadow: 8px 0 24px rgba(15, 23, 42, 0.06);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  transition: width 0.18s ease, box-shadow 0.18s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #334155;
  font-family: Inter, Outfit, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  padding: 14px 10px;
  box-sizing: border-box;

  &:hover {
    width: 280px;
    align-items: flex-start;
    box-shadow: 14px 0 36px rgba(15, 23, 42, 0.12);

    ${SidebarItemContainer} {
      display: flex;
    }

    ${SidebarItemText} {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @media (min-width: 768px) {
    width: 84px;
    padding: 16px 12px;

    &:hover {
      width: 300px;
      align-items: flex-start;
    }
  }
`

export const StyledLogo = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: cover;
  flex: 0 0 auto;
  cursor: pointer;
`

export const SidebarTop = styled.div`
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  background: #f8fafc;
  border: 1px solid rgba(226, 232, 240, 0.92);

  &:hover {
    background: #f1f5f9;
  }
`

export const SidebarBrandText = styled.div`
  min-width: 0;
  opacity: 0;
  transform: translateX(-4px);
  transition: opacity 0.16s ease, transform 0.16s ease;

  ${SidebarContainer}:hover & {
    opacity: 1;
    transform: translateX(0);
  }

  strong {
    display: block;
    color: #0f172a;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.1;
  }

  span {
    display: block;
    color: #64748b;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 2px;
  }
`

export const SidebarNavGroup = styled.nav`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px 0 8px;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SidebarNavButton = styled.button`
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px;
  border: 0;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? '#ecfdf5' : 'transparent')};
  color: ${({ $disabled, $active }) =>
    $disabled ? '#94a3b8' : $active ? '#0f766e' : '#475569'};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  box-sizing: border-box;
  text-align: left;
  transition: background 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;

  &:hover {
    background: ${({ $active, $disabled }) =>
      $disabled ? 'transparent' : $active ? '#dcfce7' : '#f1f5f9'};
    color: ${({ $disabled }) => ($disabled ? '#94a3b8' : '#0f766e')};
  }

  ${({ $active }) =>
    $active &&
    `
      box-shadow: inset 3px 0 0 #0f766e;
    `}
`

export const SidebarIconWrap = styled.span`
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${({ $active, $disabled }) =>
    $disabled ? '#f1f5f9' : $active ? '#ccfbf1' : '#ffffff'};
  border: 1px solid
    ${({ $active, $disabled }) =>
      $disabled ? '#e2e8f0' : $active ? 'rgba(20, 184, 166, 0.38)' : '#e2e8f0'};
  color: inherit;
`

export const SidebarKycIcon = muiStyled('img')`
    height: 40px;
    width: 40px;
`
export const KycSidebarPendingContent = muiStyled(DialogContent)`
display: flex;
justify-content: center;
gap: 20px;
align-items: center;
`
export const KycApprovalHeading = muiStyled('div')`
font-size: 16px;
    font-weight: 600;
`
